export default __webpack_public_path__ + "static/media/undo-icon.10d7f9c4.svg";